module.exports = __webpack_public_path__ + "static/media/bipedge-footer-image.55e5e4c0.webp";